import { useParams } from 'react-router-dom';
import { LoadingContainer } from '../common';
import { usePipelineDetails } from '../../hooks/usePipelineDetails';
import { usePipelineFilters } from '../../hooks/usePipelineFilters';
import { PipelineHeader } from './PipelineHeader';
import { PipelineActions } from './PipelineActions';
import { PipelineFilters } from './PipelineFilters';
import { PipelineStats } from './PipelineStats';
import { PipelineRunsList } from './PipelineRunsList';

export function PipelineDetails() {
  const { id } = useParams<{ id: string }>();
  
  const {
    pipeline,
    recentRuns,
    limit,
    expandedRuns,
    isLoading,
    error,
    isRefreshing,
    handleRefresh,
    handleLimitChange,
    handleToggleRunDetails,
  } = usePipelineDetails(id!);

  const {
    showFilters,
    resultFilter,
    branchFilter,
    requestedByFilter,
    filteredRuns,
    uniqueResults,
    uniqueRequesters,
    hasActiveFilters,
    setShowFilters,
    setResultFilter,
    setBranchFilter,
    setRequestedByFilter,
    clearAllFilters,
  } = usePipelineFilters(recentRuns);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <LoadingContainer
        isLoading={isLoading}
        error={error}
        loadingText="Loading pipeline details..."
        minHeight="min-h-[400px]"
        size="lg"
      >
        {pipeline && (
          <>
            {/* Header */}
            <div className="md:flex md:items-center md:justify-between">
              <PipelineHeader pipeline={pipeline} />
              <PipelineActions
                pipeline={pipeline}
                limit={limit}
                isRefreshing={isRefreshing}
                showFilters={showFilters}
                hasActiveFilters={hasActiveFilters}
                onRefresh={handleRefresh}
                onToggleFilters={() => setShowFilters(!showFilters)}
              />
            </div>

            {/* Filter Panel */}
            <PipelineFilters
              showFilters={showFilters}
              resultFilter={resultFilter}
              branchFilter={branchFilter}
              requestedByFilter={requestedByFilter}
              uniqueResults={uniqueResults}
              uniqueRequesters={uniqueRequesters}
              hasActiveFilters={hasActiveFilters}
              onResultFilterChange={setResultFilter}
              onBranchFilterChange={setBranchFilter}
              onRequestedByFilterChange={setRequestedByFilter}
              onClearFilters={clearAllFilters}
            />

            {/* Stats */}
            <PipelineStats pipelineRuns={recentRuns} />

            {/* Recent Runs */}
            <PipelineRunsList
              filteredRuns={filteredRuns}
              totalRuns={recentRuns.length}
              hasActiveFilters={hasActiveFilters}
              expandedRuns={expandedRuns}
              limit={limit}
              gitHubRepository={pipeline?.gitHubRepository}
              onToggleRunDetails={handleToggleRunDetails}
              onClearFilters={clearAllFilters}
              onRefresh={handleRefresh}
              onLimitChange={handleLimitChange}
            />
          </>
        )}
      </LoadingContainer>
    </div>
  );
}